import { render, staticRenderFns } from "./Capillaries.vue?vue&type=template&id=76b165d5"
import script from "./Capillaries.vue?vue&type=script&lang=js"
export * from "./Capillaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports